<template>
  <div class="step">
    <div class="step__question-group">
      <p class="step__question">
        How satisfied are you with the features and functionalities of the
        Infermedica <br class="step__question-linebreak" />product?
      </p>
      <FormStarRating
        v-model="rating"
        label-left="Very dissatisfied"
        label-right="Very satisfied"
      />
    </div>
    <div class="step__question-group">
      <FormBaseTextarea
        v-model="message"
        name="message"
        label="Please provide any feedback or suggestions on the product features and functionality. (optional)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const rating = defineModel<number | null>('rating')
const message = defineModel<string>('message')
</script>

<style lang="scss" scoped>
.step {
  &__question {
    font-size: var(--font-size-paragraph-s);
    font-weight: 600;
    margin-bottom: 32px;
    line-height: 26px;

    &::after {
      content: '*';
      color: var(--red-500);
    }
  }

  &__question-linebreak {
    display: none;

    @media (min-width: $breakpoint-lg) {
      display: block;
    }
  }

  &__question-group {
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
}
</style>
